import { TAG } from "../constants";
import { ShippingAddress } from "../types";
import { patientApi } from "./patientApi";

export const addressApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    /// shipping address
    getShippingAddress: builder.query<ShippingAddress, void>({
      query: () => ({
        method: "GET",
        url: "/api/patient/shipping-address",
      }),
      providesTags: [TAG.SHIPPING_ADDRESS],
    }),
    addShippingAddress: builder.mutation<
      ShippingAddress,
      Partial<ShippingAddress>
    >({
      query: (body) => ({
        method: "POST",
        url: "/api/patient/shipping-address",
        body,
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        dispatch(
          addressApi.util.updateQueryData(
            "getShippingAddress",
            undefined,
            () => data,
          ),
        );
      },
      invalidatesTags: [TAG.SHIPPING_ADDRESS, TAG.NAVIGATION],
    }),
    verifyAddress: builder.mutation<ShippingAddress, Partial<ShippingAddress>>({
      query: (body) => ({
        method: "POST",
        url: "/api/shipping-address/verify",
        body,
      }),
      invalidatesTags: [TAG.SHIPPING_ADDRESS],
    }),
    updateShippingAddress: builder.mutation<
      ShippingAddress,
      Partial<ShippingAddress>
    >({
      query: (body) => ({
        method: "PUT",
        url: "/api/patient/shipping-address",
        body,
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        const putResult = dispatch(
          addressApi.util.updateQueryData(
            "getShippingAddress",
            undefined,
            (draft) => {
              if (args != null) {
                Object.assign(draft, args);
              }
            },
          ),
        );

        try {
          const { data } = await queryFulfilled;

          dispatch(
            addressApi.util.updateQueryData(
              "getShippingAddress",
              undefined,
              (draft) => {
                Object.assign(draft, data);
              },
            ),
          );
        } catch {
          putResult.undo();
        }
      },
      invalidatesTags: [TAG.SHIPPING_ADDRESS],
    }),
  }),
});

export const {
  useAddShippingAddressMutation,
  useGetShippingAddressQuery,
  useUpdateShippingAddressMutation,
  useVerifyAddressMutation,
} = addressApi;
